// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import  VueQuillEditor from 'vue-quill-editor' 
import vueEsign from 'vue-esign'
import 'lib-flexible/flexible.js'
Vue.use(vueEsign)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.use(Vant);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
import './assets/css/main.css'
// 全局过滤器方法 迭代引入
import * as filters from './filters/index'
// 导出的是对象，可以直接通过 key 和 value 来获得过滤器的名和过滤器的方法
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


// WEBPACK FOOTER //
// ./src/main.js